<template>
  <b-card>
    <b-card-header>
      <h4 class="title">
        لیست کاربران
      </h4>
    </b-card-header>
    <b-card-body>
      <b-button
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          variant="success"
          class="mb-1 float-right"
          target="_blank"
          :href="exportExcel"
      >
        <feather-icon
            icon="FileTextIcon"
            class="mr-50"
        />
        <span class="align-middle">خروجی اکسل</span>
      </b-button>
      <b-button
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          v-b-toggle.filter-box
          variant="outline-primary"
          class="mb-1"
      >
        <feather-icon
            icon="FilterIcon"
            class="mr-50"
        />
        <span class="align-middle">جستجو</span>
      </b-button>
      <b-collapse
          id="filter-box"
          class="mb-2"
      >
        <b-card class="border mb-0">
          <b-form @submit.prevent>
            <b-row>
              <b-col md="3">
                <b-form-group>
                  <label>شناسه کاربر:</label>
                  <b-form-input
                      v-model="search.id"
                      placeholder="شناسه کاربر را وارد نمایید."
                      type="text"
                      class="d-inline-block"
                  />
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group>
                  <label>نام:</label>
                  <b-form-input
                      v-model="search.name"
                      placeholder="نام را وارد نمایید."
                      type="text"
                      class="d-inline-block"
                  />
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group>
                  <label>موبایل:</label>
                  <b-form-input
                      v-model="search.mobile"
                      placeholder="موبایل را وارد نمایید."
                      type="text"
                      class="d-inline-block"
                  />
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group>
                  <label>نام کاربری:</label>
                  <b-form-input
                      v-model="search.username"
                      placeholder="نام کاربری را وارد نمایید."
                      type="text"
                      class="d-inline-block"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="3">
                <b-overlay :show="organizationList.length === 0">
                  <b-form-group>
                    <label for="organization_id">
                      <feather-icon
                          icon="CheckSquareIcon"
                      />
                      واحد سازمانی
                    </label>
                    <v-select
                        v-model="search.organizationId"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        label="name"
                        :options="organizationList"
                        :reduce="organization => organization.id"
                    >
                    </v-select>
                  </b-form-group>
                </b-overlay>
              </b-col>

            </b-row>
            <b-row>
              <b-col md="3">
                <b-form-group
                    label="از تاریخ تولد"
                    label-for="birthdayFrom"
                >
                  <date-picker
                      v-model="search.birthdayFrom"
                      type="date"
                      display-format="jDD jMMMM jYYYY"
                      format="YYYY-MM-DD"
                      :max="search.birthdayTo"
                      simple
                      clearable
                  />

                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                    label="تا تاریخ تولد"
                    label-for="birthdayTo"
                >
                  <date-picker
                      v-model="search.birthdayTo"
                      type="date"
                      display-format="jDD jMMMM jYYYY"
                      format="YYYY-MM-DD"
                      simple
                      :min="search.birthdayFrom"
                      clearable
                  />

                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                    label="از تاریخ استخدام"
                    label-for="hireFrom"
                >
                  <date-picker
                      v-model="search.hireFrom"
                      id="hireFrom"
                      type="date"
                      display-format="jDD jMMMM jYYYY"
                      format="YYYY-MM-DD"
                      simple
                      :max="search.hireTo"
                      clearable
                  />

                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                    label="تا تاریخ استخدام"
                    label-for="due-date"
                >
                  <date-picker
                      v-model="search.hireTo"
                      id="hireTo"
                      type="date"
                      display-format="jDD jMMMM jYYYY"
                      format="YYYY-MM-DD"
                      simple
                      :min="search.hireFrom"
                      clearable
                  />

                </b-form-group>
              </b-col>

            </b-row>
            <b-row>
              <b-col md="4">
                <b-form-group
                    label=" تاریخ ایجاد"
                    label-for="due-date"
                >
                  <date-picker
                      v-model="search.createdDate"
                      type="date"
                      display-format="jDD jMMMM jYYYY"
                      format="YYYY-MM-DD"
                      clearable
                  />

                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-overlay :show="rolesList.length === 0">
                  <b-form-group>
                    <label for="role">
                      نقش
                    </label>
                    <v-select
                        v-model="search.roles"
                        multiple
                        dir="rtl"
                        label="slug"
                        :options="rolesList"
                        :reduce="role => role.id"
                        :close-on-select="false"
                    />
                  </b-form-group>
                </b-overlay>

              </b-col>
              <b-col md="4">
                <b-overlay :show="permissionList.length === 0">
                  <b-form-group>
                    <label for="permissions">
                      دسترسی
                    </label>
                    <v-select
                        v-model="search.permissions"
                        multiple
                        dir="rtl"
                        label="slug"
                        :options="permissionList"
                        :reduce="permission => permission.id"
                        :close-on-select="false"
                    />
                  </b-form-group>
                </b-overlay>
              </b-col>
              <b-col cols="12">
                <small class="text-muted">دسترسی های نامه و وظیفه</small>
              </b-col>
              <b-col md="4">
                <b-overlay :show="rolesList.length === 0">
                  <b-form-group>
                    <label for="role">
                      نقش
                    </label>
                    <v-select
                        v-model="search.ticketRoles"
                        multiple
                        dir="rtl"
                        label="slug"
                        :options="rolesList"
                        :reduce="role => role.id"
                        :close-on-select="false"
                    />
                  </b-form-group>
                </b-overlay>

              </b-col>
              <b-col md="4">
                <b-overlay :show="permissionList.length === 0">
                  <b-form-group>
                    <label for="permissions">
                      دسترسی
                    </label>
                    <v-select
                        v-model="search.ticketPermissions"
                        multiple
                        dir="rtl"
                        label="slug"
                        :options="permissionList"
                        :reduce="permission => permission.id"
                        :close-on-select="false"
                    />
                  </b-form-group>
                </b-overlay>

              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label for="permissions">
                    کاربران
                  </label>
                  <v-select
                      v-model="search.ticketUsers"
                      dir="rtl"
                      label="name"
                      :options="receiversList"
                      :reduce="receiver => receiver.id"
                      @search="onSearch"
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <hr>
            <div class="demo-inline-spacing">
              <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="primary"
                  @click="advanceSearch"
                  type="submit"
              >
                اعمال جستجو
              </b-button>
              <b-button
                  type="button"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-secondary"
                  @click="clearSearch"
              >
                حذف فیلترها
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-collapse>

      <b-overlay :show="onProgress">
        <div ref="resultTable">
          <b-table
              :fields="fields"
              :items="items"
              hover
              striped
          >
            <template #table-busy>
              <div class="text-center text-info my-2">
                <b-spinner class="align-middle"/>
                <strong> درحال دریافت اطلاعات...</strong>
              </div>
            </template>

            <template #cell(roles)="data">
              <b-badge
                  v-for="(role, index) in data.value"
                  :key="index"
                  variant="light-info"
                  class="ml-1"
              >{{
                  role
                }}
              </b-badge>

            </template>
            <template #cell(isActive)="data">
              <b-avatar
                  :id="`user-row-${data.item.id}`"
                  size="32"
                  :variant="data.value ? 'light-success': 'light-danger'"
              >
                <feather-icon
                    :icon="data.value ? 'CheckIcon': 'XIcon'"
                />
              </b-avatar>
            </template>
            <template #cell(action)="data">
              <b-dropdown
                  text="عملیات"
                  variant="outline-primary"
              >
                <b-dropdown-item :to="{name: 'Users_Update', params:{id: data.item.id}}">
                  <feather-icon
                      icon="EditIcon"
                      class="text-warning"
                  />
                  ویرایش
                </b-dropdown-item>
                <b-dropdown-item @click="deleteUser(data.item.id)">
                  <feather-icon
                      icon="XSquareIcon"
                      class="text-danger"
                  />
                  حذف
                </b-dropdown-item>
              </b-dropdown>
            </template>

          </b-table>
          <b-pagination
              v-model="currentPage"
              class="mt-2"
              :total-rows="totalRows"
              :per-page="perPage"
          />
        </div>
      </b-overlay>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardBody,
  BTable,
  BSpinner,
  BBadge,
  BDropdown,
  BDropdownItem,
  BOverlay,
  BPagination, BFormInput, BCollapse, BFormGroup, BButton, VBToggle, BAvatar,BForm
} from 'bootstrap-vue'
import VSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { doubleRaf, queryString } from '@/libs/utils'
import { computed } from '@vue/composition-api'
import { debounce } from '@/libs/debounce'

export default {
  name: 'UsersList',
  components: {
    BAvatar,
    BButton,
    VSelect,
    BFormGroup,
    BCollapse,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BTable,
    BSpinner,
    BBadge,
    BDropdown,
    BDropdownItem,
    BOverlay,
    BPagination,
    BForm
  },
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  data() {
    return {
      fields: [
        {
          key: 'id',
          label: 'شناسه',
        },
        {
          key: 'name',
          label: 'نام و نام خانوادگی',
        },
        {
          key: 'roles',
          label: 'نقش',
        },
        {
          key: 'createdDate',
          label: 'تاریخ ساخت',
        },
        {
          key: 'creator',
          label: 'سازنده',
        },
        {
          key: 'isActive',
          label: 'وضعیت',
        },
        {
          key: 'action',
          label: 'عملیات',
        },
      ],
      items: [],
      currentPage: 1,
      totalRows: 0,
      perPage: 0,
      onProgress: true,
      search: {},
      rolesList: [],
      permissionList: [],
      receiversList: [],
      organizationList: [],
      getReceivers: false,
      onExportProgress: false,
    }
  },

  computed: {
    exportExcel() {
      const query = queryString(this.search)
      return `${process.env.VUE_APP_API}user/users?export-excel=1&${query}`
    }
  },
  methods: {
    getUsersList() {
      const currentQuery = JSON.parse(JSON.stringify(this.$route.query))
      this.onProgress = true

      this.$http.get('user/users', {
        params: {
          ...currentQuery,
          ...this.search,
          page: this.currentPage,
        },
      })
          .then(({ data }) => {
            if (data.status) {
              this.items = data.users
              this.currentPage = data.meta.current_page
              this.totalRows = data.meta.total
              this.perPage = data.meta.per_page
            } else {
              this.$bvToast.toast('در دریافت لیست کاربران خطایی رخ داده', {
                title: 'حطا',
                toaster: 'b-toaster-top-right',
                variant: 'danger',
              })
            }
          })
          .catch(error => {
            console.log(error)
            this.$bvToast.toast('ارتباط با وبسرویس انجام نشد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: 'b-toaster-top-right',
              variant: 'danger',
            })
          })
          .finally(() => {
            this.onProgress = false
          })
    },
    deleteUser(id) {
      this.$swal({
        title: 'حذف کاربر',
        text: 'آیا از حذف کاربر مطمئن هستید؟',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'لغو درخواست',
        confirmButtonText: 'حذف گروه دسترسی',
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-success ml-1',
        },
      })
          .then(result => {
            if (result.value) {
              this.$swal({
                title: 'درحال انجام',
                text: 'لطفا تا دریافت نتیجه منتطر بمانید...',
                confirmButtonText: 'متوجه شدم',
              })
              this.$http.delete(`user/users/${id}`)
                  .then(({ data }) => {
                    if (data.status) {
                      this.$swal({
                        title: 'انجام شد',
                        text: 'کاربر با موفقیت حذف شد',
                        icon: 'success',
                        confirmButtonText: 'تایید',
                      })
                      this.items = []
                      this.getUsersList()
                    } else {
                      this.$swal({
                        title: 'انجام نشد',
                        text: 'در حذف کاربر خطایی رخ داده',
                        icon: 'danger',
                        confirmButtonText: 'تایید',
                      })
                    }
                  })
                  .catch(() => {
                    this.$bvToast.toast('ارتباط با وبسرویس انجام نشد', {
                      title: 'خطا در دریافت اطلاعات',
                      toaster: 'b-toaster-top-right',
                      variant: 'danger',
                    })
                  })
            }
          })
    },
    advanceSearch() {
      this.$router.replace({
        name: this.$route.name,
        query: {
          ...this.search,
        },
      })
          .then(() => {
            this.getUsersList()
          })
          .catch(() => {
          })

      doubleRaf(() => {
        this.$refs.resultTable.scrollIntoView({ behavior: 'smooth' })
      })
    },
    clearSearch() {
      this.$router.replace({
        name: this.$route.name,
        query: {},
      })
          .then(() => {
            this.getUsersList()
          })
          .catch(() => {
          })

      this.search = {}
      doubleRaf(() => {
        this.$refs.resultTable.scrollIntoView({ behavior: 'smooth' })
      })
    },
    getRoles() {
      this.$http.get('user/roles?paginate=false')
          .then(({ data }) => {
            if (data.status) {
              this.rolesList = data.roles
            } else {
              this.$bvToast.toast('دریافت لیست نقش ها با خطا مواجه شد', {
                title: 'خطا در دریافت اطلاعات',
                toaster: 'b-toaster-top-right',
                variant: 'danger',
              })
            }
          })
          .catch(() => {
            this.$bvToast.toast('ارتباط با وبسرویس انجام نشد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: 'b-toaster-top-right',
              variant: 'danger',
            })
          })
    },
    getPermissions() {
      this.$http.get('user/permissions?paginate=false')
          .then(({ data }) => {
            this.permissionList = data.permissions
          })
          .catch(() => {
            this.$bvToast.toast('ارتباط با وبسرویس انجام نشد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: 'b-toaster-top-right',
              variant: 'danger',
            })
          })
    },
    getOrganizations() {
      this.$http.get('organizations?result=all')
          .then(({ data }) => {
            this.organizationList = data.organizations
          })
          .catch(() => {
            this.$bvToast.toast('ارتباط با وبسرویس انجام نشد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: 'b-toaster-top-right',
              variant: 'danger',
            })
          })
    },
    getRelatedUsers(q) {
      this.$http.get(`user/list?name=${q}`)
          .then(({ data }) => {
            this.receiversList = data
            this.getReceivers = true
          })
          .catch(error => {
            this.$bvToast.toast('ارتباط با وبسرویس انجام نشد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
              variant: 'danger',
            })
          })
    },
    onSearch(search, loading) {
      if (search.length) {
        loading(true)
        this.searchUser(loading, search, this)
      }
    },
    searchUser: debounce((loading, search, vm) => {
      vm.getRelatedUsers(search)
      loading(false)
    }, 400),
    setSearchData() {
      doubleRaf(() => {
        this.search = JSON.parse(JSON.stringify(this.$route.query))
      })
    },
  },
  mounted() {
    this.getUsersList()
    this.getPermissions()
    this.getRoles()
    this.getOrganizations()
    this.setSearchData()
  },

  watch: {
    currentPage(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$router.push({
          name: 'Users_List',
          query: { page: this.currentPage },
        })
        this.items = []
        this.getUsersList()
      }
    },
  },
}
</script>

<style>

</style>
